import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { id: "modal-title" }
const _hoisted_3 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcModal = _resolveComponent("NcModal")!

  return (_openBlock(), _createBlock(_component_NcModal, {
    class: "memories-modal",
    ref: "modal",
    labelId: "modal-title",
    size: _ctx.size,
    outTransition: true,
    style: _normalizeStyle({ width: _ctx.isSidebarShown ? `calc(100% - ${_ctx.sidebarWidth}px)` : null }),
    additionalTrapElements: _ctx.trapElements,
    canClose: _ctx.canClose,
    onClose: _ctx.cleanup
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "container",
        onKeydown: _withModifiers(($event: any) => (0), ["stop"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title", {}, undefined, true)
          ])
        ]),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
        ])
      ], 32)
    ]),
    _: 3
  }, 8, ["size", "style", "additionalTrapElements", "canClose", "onClose"]))
}